import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  client: {
    ENV: z.string().default("production"),
    NEXT_PUBLIC_SITE_URL: z.string().default(""),
    NEXT_PUBLIC_BASE_API_URL: z.string().default("/api"),
    NEXT_PUBLIC_MEDIA_URL: z.string().default(""),
    NEXT_PUBLIC_GOOGLE_ANALYTICS_ID: z.string().default(""),
    NEXT_PUBLIC_ENABLE_PRODUCTION_FEATURES: z.string().default(""),
    NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID: z.string().default(""),
    // TODO: Fix key should never be NEXT_PUBLIC

    // SMTP
    GIPHY_API_URL: z.string().default(""),
    GIPHY_API_KEY: z.string().default(""),
    SMTP_HOST: z.string().default(""),
    SMTP_PORT: z.string().default(""),
    SMTP_USERNAME: z.string().default(""),
    SMTP_PASSWORD: z.string().default(""),
    DEFAULT_EMAIL: z.string().default(""),
    DOWNLOAD_FILE_SECRET_KEY: z.string().default(""),

    // Google service or OAuth account credentials
    GOOGLE_SERVICE_PRIVATE_KEY: z.string().default(""),
    GOOGLE_SERVICE_CLIENT_EMAIL: z.string().default(""),

    // Google sheets
    GOOGLE_SHEET_RESOURCES_ID: z.string().default(""),
    GOOGLE_SHEET_CONTACT_US_ID: z.string().default(""),
    GOOGLE_SHEET_CAREER_ID: z.string().default(""),
    GOOGLE_SHEET_PARTNERS_ID: z.string().default(""),
    GOOGLE_SHEET_COURSE_ENROLLMENT_ID: z.string().default(""),
    GOOGLE_SHEET_NEWS_LETTER_ID: z.string().default(""),
    GOOGLE_SHEET_REQUEST_ACCESS_ID: z.string().default(""),
    GOOGLE_SHEET_CUSTOM_FORM_ID: z.string().default(""),
    GOOGLE_SHEET_RESOURCES_SHEET_NAME: z.string().default(""),
    GOOGLE_SHEET_CONTACT_US_SHEET_NAME: z.string().default(""),
    GOOGLE_SHEET_CAREER_SHEET_NAME: z.string().default(""),
    GOOGLE_SHEET_PARTNERS_SHEET_NAME: z.string().default(""),
    GOOGLE_SHEET_COURSE_ENROLLMENT_SHEET_NAME: z.string().default(""),
    GOOGLE_SHEET_NEWS_LETTER_SHEET_NAME: z.string().default(""),
    GOOGLE_SHEET_REQUEST_ACCESS_SHEET_NAME: z.string().default(""),

    // google drive
    GOOGLE_DRIVE_FOLDER_ID: z.string().default(""),

    // google recaptcha
    NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY: z.string().default(""),
    GOOGLE_RECAPTCHA_SECRET_KEY: z.string().default(""),
    SECURE_FORM_TOKEN: z.string().default(""),

    // zero bounce credential
    ZERO_BOUNCE_URL: z.string().default(""),
    ZERO_BOUNCE_API_KEY: z.string().default(""),
    // zero bounce debug mode, when enabled, it logs email validation results
    ZEROBOUNCE_DEBUG: z.string().default(""),

    // sendy credential
    SENDY_API_KEY: z.string().default(""),
    SENDY_SUBSCRIPTION_URL: z.string().default(""),
    SENDY_SUBSCRIBER_LIST_ID: z.string().default(""),
  },
  experimental__runtimeEnv: {
    ENV: process.env.ENV,
    NEXT_PUBLIC_SITE_URL: process.env.NEXT_PUBLIC_SITE_URL,
    NEXT_PUBLIC_BASE_API_URL: process.env.NEXT_PUBLIC_BASE_API_URL,
    NEXT_PUBLIC_MEDIA_URL: process.env.NEXT_PUBLIC_MEDIA_URL,
    NEXT_PUBLIC_GOOGLE_ANALYTICS_ID:
      process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID,
    NEXT_PUBLIC_ENABLE_PRODUCTION_FEATURES:
      process.env.NEXT_PUBLIC_ENABLE_PRODUCTION_FEATURES,
    // TODO: Fix key should never be NEXT_PUBLIC
    NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID:
      process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID,
    GIPHY_API_URL: process.env.GIPHY_API_URL,
    GIPHY_API_KEY: process.env.GIPHY_API_KEY,
    SMTP_HOST: process.env.SMTP_HOST,
    SMTP_PORT: process.env.SMTP_PORT,
    SMTP_USERNAME: process.env.SMTP_USERNAME,
    SMTP_PASSWORD: process.env.SMTP_PASSWORD,
    DEFAULT_EMAIL: process.env.DEFAULT_EMAIL,
    DOWNLOAD_FILE_SECRET_KEY: process.env.DOWNLOAD_FILE_SECRET_KEY,
    GOOGLE_SERVICE_CLIENT_EMAIL: process.env.GOOGLE_SERVICE_CLIENT_EMAIL,
    GOOGLE_SERVICE_PRIVATE_KEY: process.env.GOOGLE_SERVICE_PRIVATE_KEY,
    GOOGLE_SHEET_RESOURCES_ID: process.env.GOOGLE_SHEET_RESOURCES_ID,
    GOOGLE_SHEET_CONTACT_US_ID: process.env.GOOGLE_SHEET_CONTACT_US_ID,
    GOOGLE_SHEET_CAREER_ID: process.env.GOOGLE_SHEET_CAREER_ID,
    GOOGLE_SHEET_PARTNERS_ID: process.env.GOOGLE_SHEET_PARTNERS_ID,
    GOOGLE_SHEET_COURSE_ENROLLMENT_ID:
      process.env.GOOGLE_SHEET_COURSE_ENROLLMENT_ID,
    GOOGLE_SHEET_NEWS_LETTER_ID: process.env.GOOGLE_SHEET_NEWS_LETTER_ID,
    GOOGLE_SHEET_REQUEST_ACCESS_ID: process.env.GOOGLE_SHEET_REQUEST_ACCESS_ID,
    GOOGLE_SHEET_CUSTOM_FORM_ID: process.env.GOOGLE_SHEET_CUSTOM_FORM_ID,
    GOOGLE_SHEET_RESOURCES_SHEET_NAME:
      process.env.GOOGLE_SHEET_RESOURCES_SHEET_NAME,
    GOOGLE_SHEET_CONTACT_US_SHEET_NAME:
      process.env.GOOGLE_SHEET_CONTACT_US_SHEET_NAME,
    GOOGLE_SHEET_CAREER_SHEET_NAME: process.env.GOOGLE_SHEET_CAREER_SHEET_NAME,
    GOOGLE_SHEET_PARTNERS_SHEET_NAME:
      process.env.GOOGLE_SHEET_PARTNERS_SHEET_NAME,
    GOOGLE_SHEET_COURSE_ENROLLMENT_SHEET_NAME:
      process.env.GOOGLE_SHEET_COURSE_ENROLLMENT_SHEET_NAME,
    GOOGLE_SHEET_NEWS_LETTER_SHEET_NAME:
      process.env.GOOGLE_SHEET_NEWS_LETTER_SHEET_NAME,
    GOOGLE_SHEET_REQUEST_ACCESS_SHEET_NAME:
      process.env.GOOGLE_SHEET_REQUEST_ACCESS_SHEET_NAME,
    GOOGLE_DRIVE_FOLDER_ID: process.env.GOOGLE_DRIVE_FOLDER_ID,
    NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY:
      process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY,
    GOOGLE_RECAPTCHA_SECRET_KEY: process.env.GOOGLE_RECAPTCHA_SECRET_KEY,
    SECURE_FORM_TOKEN: process.env.SECURE_FORM_TOKEN,
    ZERO_BOUNCE_API_KEY: process.env.ZERO_BOUNCE_API_KEY,
    ZERO_BOUNCE_URL: process.env.ZERO_BOUNCE_URL,
    SENDY_API_KEY: process.env.SENDY_API_KEY,
    SENDY_SUBSCRIPTION_URL: process.env.SENDY_SUBSCRIPTION_URL,
    SENDY_SUBSCRIBER_LIST_ID: process.env.SENDY_SUBSCRIBER_LIST_ID,
  },
});
